/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { overflowEllipsis } from 'src/styles/mixins';

export const IssueCardLink = styled.a({
  display: 'flex',
  color: 'inherit',
  textDecoration: 'inherit',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: token('space.150'),
  position: 'relative',
  height: token('space.800'),
  marginBottom: token('space.100'),
  background: token('elevation.surface'),
  boxShadow: token('elevation.shadow.raised'),
  // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
  borderRadius: token('border.radius', '3px'),
  '&:hover, &:active, &:focus': {
    backgroundColor: token('elevation.surface.hovered'),
    color: 'inherit',
    textDecoration: 'inherit',
  },
  cursor: 'pointer',
});

export const BottomContentContainer = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const BottomLeftContentContainer = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const BottomRightContentContainer = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const DoneIconContainer = styled.div({
  marginRight: `${gridSize() / 2}px`,
  marginBottom: `${gridSize() / 2}px`,
});

export const SummaryTextContainer = styled.div(
  {
    height: `${gridSize() * 3}px`,
    font: token('font.body'),
  },
  overflowEllipsis()
);

export const IssueKeyContainer = styled.span({
  font: token('font.heading.xxsmall'),
  color: token('color.text.subtlest'),
  marginTop: 0,
  marginLeft: `${gridSize()}px`,
});
